import { ButtonBase } from '@/shared/ui';

import { normalizeSx } from '@/shared/lib/normalizeSx';

import type { Sx } from '@/shared/types/uiTypes';

/**
 * Minimum width (px) of a column toggle tile. Shared with the grid templates in
 * DisplaySettingsPanel so the tile's floor and the grid track's floor stay in
 * lockstep — change the tile size in one place.
 */
export const COLUMN_TILE_MIN_WIDTH = 120;

type ColumnToggleTileProps = {
  label: string;
  checked: boolean;
  onToggle: () => void;
  sx?: Sx;
};

/**
 * A single column-visibility toggle in the Display Settings panel. The whole
 * tile is clickable — there is no separate checkbox glyph; selection state is
 * conveyed entirely through fill/border/text color, per the Figma redesign.
 */
const ColumnToggleTile = ({ label, checked, onToggle, sx }: ColumnToggleTileProps) => (
  <ButtonBase
    aria-pressed={checked}
    sx={[
      {
        width: '100%',
        minWidth: COLUMN_TILE_MIN_WIDTH,
        height: 24,
        px: '6.5px',
        fontSize: '9px',
        fontWeight: 500,
        border: '0.5px solid',
        borderColor: checked ? 'gx.text' : 'gx.border',
        backgroundColor: checked ? 'gx.response' : 'gx.mainBackground',
        color: checked ? 'gx.text' : 'table.infoRowText'
      },
      ...normalizeSx(sx)
    ]}
    onClick={onToggle}
  >
    {label}
  </ButtonBase>
);

export default ColumnToggleTile;
